import { createSelector } from 'reselect'

export const getCenterOfExcellenceState = ($$state: $TSFixMe) => $$state.get('centerOfExcellence')

export const getNeurodiversitySearcherInfo = createSelector(getCenterOfExcellenceState, ($$centerOfExcellenceState) =>
  $$centerOfExcellenceState.get('neurodiversitySearcherInfo'),
)
